import HomePageInit from './HomePageInit';
import ClientCarousel from './ClientCarousel';
import Acidy from './Acidy';

HomePageInit.init();
ClientCarousel.init();
Acidy.init();
